// src/pages/tickets/components/TicketHistorial.tsx
import { Card, Avatar, Badge, Spinner } from '@/components/ui';
import { formatDateTime } from '@/lib/utils';
import { useHistorial } from '@/hooks/queries/useTickets';

interface Props {
  ticketId: string;
}

const CAMPO_LABELS: Record<string, string> = {
  estado: 'Estado',
  prioridad: 'Prioridad',
  asignado_a_id: 'Asignado',
  tipo: 'Tipo',
  titulo: 'Título',
  descripcion: 'Descripción',
  fecha_limite: 'Fecha Límite',
};

export function TicketHistorial({ ticketId }: Props) {
  const { data: historial, isLoading } = useHistorial(ticketId);

  if (isLoading) {
    return (
      <Card className="p-4 flex justify-center">
        <Spinner />
      </Card>
    );
  }

  return (
    <Card className="p-4">
      <div className="space-y-4">
        {historial?.map((item) => (
          <div key={item.id} className="flex gap-3 pb-4 border-b last:border-0">
            <Avatar fallback={item.usuario?.nombre} size="sm" />
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <span className="font-medium text-sm">{item.usuario?.nombre}</span>
                <span className="text-xs text-gray-400">{formatDateTime(item.created_at)}</span>
              </div>
              <p className="text-sm text-gray-700">
                Cambio <strong>{CAMPO_LABELS[item.campo] || item.campo}</strong>
                {item.valor_anterior && (
                  <>
                    {' de '}
                    <Badge variant="default" className="mx-1">
                      {item.valor_anterior}
                    </Badge>
                  </>
                )}
                {' a '}
                <Badge variant="primary" className="mx-1">
                  {item.valor_nuevo}
                </Badge>
              </p>
              {item.comentario && (
                <p className="text-sm text-gray-500 mt-1 italic">"{item.comentario}"</p>
              )}
            </div>
          </div>
        ))}

        {historial?.length === 0 && (
          <p className="text-center text-gray-500 py-4">No hay cambios registrados</p>
        )}
      </div>
    </Card>
  );
}
